
import { ref, watch, computed } from 'vue'
import { axiosInstance } from '@/plugins/axios'

    const inspectionSites = ref([])
const routeLoading = ref(false)
    const currentPage = ref(1)
    const perPage = ref(10)
    const totalRecords = ref()


export const useInspectionSite = () =>
{

    
    const getSites = async () => {
        routeLoading.value = true
        inspectionSites.value = []
  const { data } = await axiosInstance.get(`/v1/inspection-sites?page=${currentPage.value}&limit=${perPage.value}&sort[created_at]=desc`)
  inspectionSites.value = data.data
  totalRecords.value = data.metadata.total
  routeLoading.value = false
}
return { getSites, inspectionSites, routeLoading, currentPage, perPage, totalRecords }
}



